
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReporterTypeBase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReporterType"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reporterName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sftpUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sftpUploadPath"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sftpDownloadPath"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"username"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"active"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"test"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"encrypted"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"signatoryId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"signatorySubId"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":182}};
    doc.loc.source = {"body":"fragment ReporterTypeBase on ReporterType {\n  id\n  reporterName\n  sftpUrl\n  sftpUploadPath\n  sftpDownloadPath\n  username\n  active\n  test\n  encrypted\n  signatoryId\n  signatorySubId\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
